export const faqs = [
  {
    q: 'Funziona con gruppi di qualsiasi livello?',
    a: 'Sì. Ogni sessione include la Versione A per principianti, la Versione B per intermedi e la Versione C per avanzati. Puoi tenere la stessa lezione a un gruppo misto senza alcun problema.',
  },
  {
    q: 'In che valuta pago?',
    a: 'Il prezzo è in euro (EUR). Paghi direttamente in euro, senza conversioni e senza costi nascosti. Un unico pagamento di 19€.',
  },
  {
    q: 'Come ricevo il materiale?',
    a: "Accesso immediato entro 5 minuti. Dopo il pagamento ricevi un'email con il tuo link personale. Scarichi tutti i 6 Volumi in PDF: i file sono tuoi PER SEMPRE. Stampali o usali direttamente da smartphone, tablet o computer.",
  },
  {
    q: 'Serve attrezzatura speciale?',
    a: 'NO, solo attrezzatura di base. Le sessioni usano bilancieri, manubri, kettlebell, box pliometrici, TRX e tappetini. Se la tua palestra ha il minimo indispensabile, SEI A POSTO.',
  },
  {
    q: 'Funziona se sono un istruttore di palestra e non un insegnante di educazione fisica?',
    a: "SÌ, il 70% dei nostri clienti sono istruttori di palestra. Megapack Funzionale 365 è pensato per insegnanti di educazione fisica, istruttori di palestra, coach di CrossFit, personal trainer e preparatori atletici.",
  },
  {
    q: 'La garanzia è reale?',
    a: "Reale al 100%: niente moduli, niente complicazioni. Acquista oggi e se entro 7 giorni non ti convince, mandaci un'email e ti rimborsiamo. Non ti chiederemo il perché. Meno del 2% chiede il rimborso.",
  },
  {
    q: 'Sono alle prime armi: servono conoscenze di programmazione?',
    a: "NO. Non devi conoscere la periodizzazione né la teoria avanzata. Ogni sessione è GIÀ costruita con obiettivo, esercizi e serie. Apri, leggi, insegna. Funziona sia per i coach nuovi sia per quelli esperti: il 40% dei nostri clienti ha appena iniziato.",
  },
  {
    q: 'Posso usarlo con più di un gruppo?',
    a: 'SÌ, uso illimitato con tutti i tuoi gruppi. Un solo pagamento = accesso a vita. Usalo con 1 gruppo, 5 gruppi o 20 gruppi. Nessun limite.',
  },
]
